export const categoryInfo = {
  korean: { name: '韩漫', slug: 'korean', icon: 'ri-heart-pulse-line', desc: '韩国漫画以其精致的画风和扣人心弦的剧情著称，涵盖恋爱、奇幻、都市等多种题材。' },
  japanese: { name: '日漫', slug: 'japanese', icon: 'ri-sword-line', desc: '日本动漫经典辈出，从热血少年到治愈日常，风格多样，全球粉丝无数。' },
  chinese: { name: '国漫', slug: 'chinese', icon: 'ri-building-2-line', desc: '国漫崛起，融合东方美学与现代叙事，仙侠、玄幻、古风等题材独树一帜。' },
};

export interface AnimeItem {
  id: number;
  title: string;
  category: 'korean' | 'japanese' | 'chinese';
  cover: string;
  description: string;
  shortDesc: string;
  author: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  tags: string[];
  chapters: number;
  latestChapter: string;
  updatedAt: string;
}

export const animeList: AnimeItem[] = [
  {
    id: 1,
    title: '女神降临',
    category: 'korean',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20makeup%20transformation%2C%20soft%20romantic%20atmosphere%2C%20clean%20background%20with%20warm%20pastel%20tones%2C%20elegant%20character%20design%2C%20digital%20art%20style%20with%20detailed%20eyes%20and%20flowing%20hair&width=600&height=800&seq=anime-cover-01&orientation=portrait',
    description: '《女神降临》讲述了平凡女孩通过化妆技巧变身校园女神的浪漫喜剧故事。女主角林周京因外貌饱受歧视，转学后用精湛的化妆技术开启全新人生，却意外卷入两大校草的争夺战中，笑料与感动交织。',
    shortDesc: '平凡女孩靠化妆逆袭，两大校草为她倾心，浪漫喜剧一触即发！',
    author: '喵喵/Yaongyi',
    status: '连载中',
    rating: 9.5,
    views: '1280万',
    tags: ['恋爱', '校园', '喜剧', '逆袭'],
    chapters: 238,
    latestChapter: '第238话 新的开始',
    updatedAt: '2026-08-03',
  },
  {
    id: 2,
    title: '我独自升级',
    category: 'korean',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20illustration%20of%20a%20powerful%20male%20hunter%20with%20glowing%20purple%20eyes%20and%20black%20armor%2C%20epic%20action%20pose%2C%20dungeon%20background%20with%20dark%20shadows%2C%20dramatic%20lighting%2C%20intense%20atmosphere&width=600&height=800&seq=anime-cover-02&orientation=portrait',
    description: '《我独自升级》讲述世界上出现了连接异次元的"门"，觉醒者们进入地下城猎杀怪物。E级猎人成振宇在一场生死危机后获得了神秘系统的能力，成为唯一可以"升级"的猎人，开始了从最弱到最强的逆袭之路。',
    shortDesc: '从最弱到最强！E级猎人获得神秘系统，开启逆天升级之路！',
    author: 'Chugong/h-goon',
    status: '已完结',
    rating: 9.8,
    views: '3560万',
    tags: ['奇幻', '战斗', '升级', '热血'],
    chapters: 179,
    latestChapter: '第179话 终章',
    updatedAt: '2026-07-15',
  },
  {
    id: 3,
    title: '鬼灭之刃',
    category: 'japanese',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20manga%20illustration%20of%20a%20young%20swordsman%20with%20green%20checkered%20haori%20and%20a%20demon%20slayer%20sword%2C%20traditional%20Japanese%20aesthetic%2C%20dramatic%20action%20scene%20with%20water%20breathing%20effects%2C%20moonlight%20background&width=600&height=800&seq=anime-cover-03&orientation=portrait',
    description: '《鬼灭之刃》以日本大正时代为背景，少年灶门炭治郎全家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹复原的方法，炭治郎加入鬼杀队，踏上了斩鬼之旅。',
    shortDesc: '少年为救变成鬼的妹妹，踏上斩鬼之旅！热血与温情的巅峰之作！',
    author: '吾峠呼世晴',
    status: '已完结',
    rating: 9.7,
    views: '8920万',
    tags: ['热血', '战斗', '少年', '奇幻', '兄妹'],
    chapters: 205,
    latestChapter: '第205话 未来的模样',
    updatedAt: '2026-06-20',
  },
  {
    id: 4,
    title: '间谍过家家',
    category: 'japanese',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20spy%20family%20illustration%20featuring%20a%20suited%20gentleman%20spy%2C%20a%20beautiful%20female%20assassin%2C%20and%20a%20cute%20little%20girl%20with%20pink%20hair%2C%20warm%20family%20atmosphere%2C%20comedic%20expression%2C%20clean%20pastel%20color%20palette&width=600&height=800&seq=anime-cover-04&orientation=portrait',
    description: '《间谍过家家》讲述了顶级间谍"黄昏"为执行任务临时组建家庭，却不知"妻子"是杀手，"女儿"是超能力者。三个各怀秘密的人组成虚假家庭，在啼笑皆非的日常中逐渐建立真正的羁绊。',
    shortDesc: '间谍父亲+杀手母亲+超能力女儿=史上最强伪装家庭！',
    author: '远藤达哉',
    status: '连载中',
    rating: 9.6,
    views: '6450万',
    tags: ['喜剧', '家庭', '间谍', '温馨'],
    chapters: 102,
    latestChapter: '第102话 家庭旅行',
    updatedAt: '2026-08-02',
  },
  {
    id: 5,
    title: '全职高手',
    category: 'chinese',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20animation%20style%20illustration%20of%20a%20cool%20male%20gamer%20with%20silver%20hair%20holding%20a%20gaming%20mouse%2C%20esports%20theme%2C%20cyberpunk%20aesthetic%2C%20dynamic%20composition%2C%20professional%20gaming%20atmosphere&width=600&height=800&seq=anime-cover-05&orientation=portrait',
    description: '《全职高手》讲述了网游荣耀中被誉为"斗神"的顶尖高手叶修，因种种原因被俱乐部驱逐。离开职业圈的他寄身于一家网吧，重新开始游戏生涯，凭借一把自制武器"千机伞"，重返巅峰之路。',
    shortDesc: '被驱逐的顶尖高手，从网吧重新出发，重返荣耀巅峰！',
    author: '蝴蝶蓝',
    status: '已完结',
    rating: 9.4,
    views: '4210万',
    tags: ['游戏', '电竞', '热血', '竞技'],
    chapters: 320,
    latestChapter: '第320话 十年荣耀',
    updatedAt: '2026-05-30',
  },
  {
    id: 6,
    title: '斗罗大陆',
    category: 'chinese',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20fantasy%20illustration%20of%20a%20young%20warrior%20with%20blue%20silver%20grass%20martial%20spirit%2C%20ancient%20Chinese%20fantasy%20costume%2C%20epic%20fantasy%20atmosphere%2C%20spirit%20ring%20glowing%20effects%2C%20grand%20landscape%20background&width=600&height=800&seq=anime-cover-06&orientation=portrait',
    description: '《斗罗大陆》讲述唐门外门弟子唐三偷学内门绝学被追至悬崖边，跳崖明志后穿越到斗罗大陆。在这片武魂的世界，他凭借前世的记忆和毅力，一步步走向魂师巅峰。',
    shortDesc: '唐门弟子穿越异界，觉醒双生武魂，踏上魂师巅峰之路！',
    author: '唐家三少',
    status: '连载中',
    rating: 9.3,
    views: '7230万',
    tags: ['玄幻', '穿越', '热血', '修炼'],
    chapters: 456,
    latestChapter: '第456话 海神传承',
    updatedAt: '2026-08-04',
  },
  {
    id: 7,
    title: '蓝色监狱',
    category: 'japanese',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20sports%20manga%20illustration%20of%20an%20intense%20male%20soccer%20player%20in%20blue%20uniform%20with%20sharp%20eyes%2C%20dynamic%20action%20on%20soccer%20field%2C%20dramatic%20angle%2C%20competitive%20atmosphere%2C%20speed%20lines&width=600&height=800&seq=anime-cover-07&orientation=portrait',
    description: '《蓝色监狱》讲述日本足球协会为了培养出世界第一的前锋，将300名高中前锋关进名为"蓝色监狱"的训练设施。只有最终的胜者才能成为日本代表，而失败者将永远失去进入国家队的资格。',
    shortDesc: '300名前锋被关进"蓝色监狱"，只有最强才能存活！',
    author: '金城宗幸/野村优介',
    status: '连载中',
    rating: 9.2,
    views: '2890万',
    tags: ['体育', '足球', '竞技', '生存'],
    chapters: 265,
    latestChapter: '第265话 最终选拔',
    updatedAt: '2026-08-01',
  },
  {
    id: 8,
    title: '社内相亲',
    category: 'korean',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20illustration%20of%20a%20young%20professional%20woman%20and%20a%20handsome%20CEO%20man%20in%20office%20setting%2C%20romantic%20comedy%20vibe%2C%20modern%20fashion%2C%20warm%20lighting%2C%20elegant%20corporate%20atmosphere&width=600&height=800&seq=anime-cover-08&orientation=portrait',
    description: '《社内相亲》讲述普通上班族申夏莉代替闺蜜去相亲，却意外发现相亲对象正是自己公司的社长姜泰武。两人在隐瞒与试探之间展开了一段啼笑皆非的办公室恋情。',
    shortDesc: '替闺蜜相亲，对象竟是自己社长！办公室恋情的爆笑开端！',
    author: 'Haehwa/Narak',
    status: '已完结',
    rating: 9.1,
    views: '1980万',
    tags: ['恋爱', '职场', '喜剧', '契约'],
    chapters: 125,
    latestChapter: '第125话 幸福结局',
    updatedAt: '2026-04-10',
  },
  {
    id: 9,
    title: '一念永恒',
    category: 'chinese',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20cultivation%20fantasy%20illustration%20of%20a%20young%20immortal%20cultivator%20in%20white%20robes%20with%20flowing%20hair%2C%20ancient%20Chinese%20mountain%20landscape%2C%20mystical%20energy%20effects%2C%20ethereal%20atmosphere%2C%20ink%20wash%20painting%20style&width=600&height=800&seq=anime-cover-09&orientation=portrait',
    description: '《一念永恒》讲述白小纯为追求长生不老踏上修仙之路。他胆小怕死却天赋异禀，在修仙界闹出无数笑话的同时，一步步走向巅峰。一念成仙，一念成魔，全在一念之间。',
    shortDesc: '胆小怕死的修仙少年，凭借奇葩天赋横行修仙界！',
    author: '耳根',
    status: '连载中',
    rating: 9.0,
    views: '3560万',
    tags: ['修仙', '搞笑', '玄幻', '冒险'],
    chapters: 380,
    latestChapter: '第380话 丹道大成',
    updatedAt: '2026-08-03',
  },
  {
    id: 10,
    title: '咒术回战',
    category: 'japanese',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20illustration%20of%20a%20teenage%20boy%20with%20spiky%20pink%20hair%20in%20school%20uniform%2C%20surrounded%20by%20cursed%20energy%2C%20urban%20supernatural%20setting%2C%20dramatic%20contrast%20lighting%2C%20intense%20action%20vibe&width=600&height=800&seq=anime-cover-10&orientation=portrait',
    description: '《咒术回战》讲述高中生虎杖悠仁吞下诅咒之王两面宿傩的手指后成为宿傩的容器。为了收集散落的手指，他加入东京都立咒术高等专门学校，与同伴一起对抗诅咒。',
    shortDesc: '吞下诅咒之王手指的少年，成为最强咒术师的战斗物语！',
    author: '芥见下下',
    status: '连载中',
    rating: 9.6,
    views: '5680万',
    tags: ['战斗', '奇幻', '黑暗', '校园'],
    chapters: 271,
    latestChapter: '第271话 最终决战',
    updatedAt: '2026-08-04',
  },
  {
    id: 11,
    title: '天官赐福',
    category: 'chinese',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20beautiful%20fantasy%20illustration%20of%20a%20graceful%20male%20immortal%20in%20flowing%20red%20and%20white%20hanfu%20robes%2C%20ancient%20Chinese%20celestial%20palace%20background%2C%20soft%20ethereal%20lighting%2C%20romantic%20elegant%20atmosphere&width=600&height=800&seq=anime-cover-11&orientation=portrait',
    description: '《天官赐福》讲述仙乐太子谢怜第三次飞升，却因没有信徒而被贬下凡。在凡间他遇到了神秘的红衣少年花城，两人携手解开八百年前的谜团，一段跨越三界的因缘由此展开。',
    shortDesc: '三度飞升的落魄太子，与神秘鬼王共赴八百年前的约定！',
    author: '墨香铜臭',
    status: '已完结',
    rating: 9.7,
    views: '5120万',
    tags: ['仙侠', '古风', '奇幻', '悬疑'],
    chapters: 244,
    latestChapter: '第244话 花好月圆',
    updatedAt: '2026-03-15',
  },
  {
    id: 12,
    title: '金秘书为何那样',
    category: 'korean',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20illustration%20of%20a%20professional%20female%20secretary%20and%20a%20narcissistic%20handsome%20boss%20in%20modern%20office%2C%20romantic%20tension%2C%20clean%20professional%20attire%2C%20warm%20office%20lighting&width=600&height=800&seq=anime-cover-12&orientation=portrait',
    description: '《金秘书为何那样》讲述完美主义自恋狂副会长李英俊的贴身秘书金微笑突然提出辞职。为留住这位全能秘书，李英俊使出浑身解数，却发现自己的心早已沦陷。',
    shortDesc: '全能秘书突然辞职，自恋副会长慌了！办公室恋曲的甜蜜开端！',
    author: '郑景允',
    status: '已完结',
    rating: 9.2,
    views: '1670万',
    tags: ['恋爱', '职场', '喜剧', '甜宠'],
    chapters: 98,
    latestChapter: '第98话 永远在一起',
    updatedAt: '2026-02-28',
  },
];

export function getAnimeByCategory(category: string): AnimeItem[] {
  return animeList.filter(item => item.category === category);
}

export function getAnimeById(id: number): AnimeItem | undefined {
  return animeList.find(item => item.id === id);
}

export function getFeaturedAnime(): AnimeItem[] {
  return animeList.filter(item => item.rating >= 9.5).slice(0, 6);
}

export function getLatestUpdates(): AnimeItem[] {
  return [...animeList].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 6);
}

export const faqData = [
  {
    question: '51动漫网的动漫资源是否需要付费？',
    answer: '51动漫网站上的所有动漫资源均为免费观看，无需任何付费。我们致力于为广大动漫爱好者提供优质的免费动漫观看体验，涵盖韩漫、日漫、国漫等多种类型，全部免费全集在线。',
  },
  {
    question: '如何使用下拉式阅读模式？',
    answer: '在51动漫观看漫画时，您只需在漫画详情页点击"下拉式阅读"模式即可。页面会自动将所有内容纵向排列，您只需向下滚动即可连续阅读，无需手动翻页，带来更流畅的追更体验。',
  },
  {
    question: '51动漫支持哪些类型的动漫？',
    answer: '51动漫网涵盖了韩漫（韩国漫画）、日漫（日本动漫）和国漫（国产动漫）三大类。韩漫以恋爱、奇幻题材为主，日漫涵盖热血、战斗、日常等多样风格，国漫则以仙侠、玄幻、古风为特色，满足不同读者的喜好。',
  },
  {
    question: '动漫资源多久更新一次？',
    answer: '51动漫与各大漫画平台保持同步更新，热门连载作品通常每周更新一话。我们会在第一时间同步最新内容，确保追更党不错过任何一个精彩章节。您可以在网站首页查看最新更新列表。',
  },
  {
    question: '在51动漫网看动漫需要注意什么？',
    answer: '建议使用支持HTML5的现代浏览器访问51动漫网站以获得最佳阅读体验。下拉式阅读模式下建议保持网络连接稳定。所有内容仅供个人欣赏学习，请支持正版。',
  },
];

export const testimonials = [
  {
    name: '动漫迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20anime%20fan%20portrait%2C%20casual%20style%2C%20friendly%20smile%2C%20simple%20headshot%20on%20plain%20light%20background%2C%20clean%20composition&width=120&height=120&seq=avatar-01&orientation=squarish',
    comment: '51动漫真的是我发现的最全面的动漫网站！韩漫日漫国漫都有，每天都要刷一刷，追更太方便了！',
    rating: 5,
  },
  {
    name: '二次元居民',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20woman%20portrait%20with%20anime%20style%20accessories%2C%20modern%20casual%20fashion%2C%20bright%20smile%2C%20clean%20simple%20headshot%20on%20plain%20light%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    comment: '下拉式阅读体验太棒了！不用一页页翻，一口气能看好多话。资源更新也很及时，强烈推荐！',
    rating: 5,
  },
  {
    name: '追更达人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20portrait%20with%20glasses%2C%20friendly%20expression%2C%20modern%20casual%20look%2C%20clean%20simple%20headshot%20on%20plain%20light%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    comment: '自从用了51动漫网，再也不用到处找资源了。分类清晰，搜索方便，追更列表管理得明明白白！',
    rating: 5,
  },
];

export const statsData = [
  { label: '动漫作品', value: '12,000+', icon: 'ri-movie-2-line' },
  { label: '日活用户', value: '50万+', icon: 'ri-user-smile-line' },
  { label: '累计阅读', value: '3.2亿+', icon: 'ri-eye-line' },
  { label: '每日更新', value: '200+', icon: 'ri-refresh-line' },
];